import { makeNetTerms } from '~/infra/translator';
import { assertUnreachable } from '~/infra/utils';
export var AmendmentDraftChangeType = /*#__PURE__*/ function(AmendmentDraftChangeType) {
    AmendmentDraftChangeType["UpdateServiceCost"] = "updateServiceCost";
    AmendmentDraftChangeType["UpdateNetTerms"] = "updateNetTerms";
    AmendmentDraftChangeType["UpdateServiceName"] = "updateServiceName";
    AmendmentDraftChangeType["UpdateServiceDescription"] = "updateServiceDescription";
    AmendmentDraftChangeType["UpdateServiceTerms"] = "updateServiceTerms";
    AmendmentDraftChangeType["RemoveServiceTerms"] = "removeServiceTerms";
    AmendmentDraftChangeType["UpdateServiceBilledUpon"] = "updateServiceBilledUpon";
    AmendmentDraftChangeType["UpdateServiceBundle"] = "updateServiceBundle";
    AmendmentDraftChangeType["RemoveServiceBundle"] = "removeServiceBundle";
    AmendmentDraftChangeType["AddService"] = "addService";
    AmendmentDraftChangeType["TerminateService"] = "terminateService";
    AmendmentDraftChangeType["CancelService"] = "cancelService";
    AmendmentDraftChangeType["UpdateServiceIntegratedClass"] = "updateServiceIntegratedClass";
    AmendmentDraftChangeType["UpdateManualPayments"] = "updateManualPayments";
    AmendmentDraftChangeType["UpdateCoverCreditCardFees"] = "updateCoverCreditCardFees";
    AmendmentDraftChangeType["UpdateLegalTermsDocuments"] = "updateLegalTermsDocuments";
    AmendmentDraftChangeType["UpdateAmendmentsApprovalMethod"] = "updateAmendmentsApprovalMethod";
    AmendmentDraftChangeType["UpdateInvoicesApprovalMethod"] = "updateInvoicesApprovalMethod";
    AmendmentDraftChangeType["AddCustomPage"] = "addCustomPage";
    AmendmentDraftChangeType["UpdateCustomPage"] = "updateCustomPage";
    return AmendmentDraftChangeType;
}({});
export var ServiceCostConflict = /*#__PURE__*/ function(ServiceCostConflict) {
    ServiceCostConflict["PriceIncreased"] = "priceIncreased";
    ServiceCostConflict["DiscountExpired"] = "discountExpired";
    return ServiceCostConflict;
}({});
export var LastModificationType = /*#__PURE__*/ function(LastModificationType) {
    LastModificationType["NeverModified"] = "neverModified";
    LastModificationType["Modified"] = "modified";
    return LastModificationType;
}({});
export const neverModified = ()=>({
        type: "neverModified"
    });
export const modifiedBy = (modified)=>({
        type: "modified",
        modified
    });
export const lastModificationFromDTO = (dto)=>dto !== null && dto !== void 0 ? dto : neverModified();
export const modificationRecordOf = (lastModification)=>lastModification.type === "modified" ? lastModification.modified : undefined;
export function acceptAmendmentDraftChange(change, visitor) {
    switch(change.type){
        case "updateServiceCost":
            var _visitor_visitUpdateServiceCost;
            return (_visitor_visitUpdateServiceCost = visitor.visitUpdateServiceCost) === null || _visitor_visitUpdateServiceCost === void 0 ? void 0 : _visitor_visitUpdateServiceCost.call(visitor, change.value);
        case "updateNetTerms":
            var _visitor_visitUpdateNetTerms;
            return (_visitor_visitUpdateNetTerms = visitor.visitUpdateNetTerms) === null || _visitor_visitUpdateNetTerms === void 0 ? void 0 : _visitor_visitUpdateNetTerms.call(visitor, change.value);
        case "updateServiceName":
            var _visitor_visitUpdateServiceName;
            return (_visitor_visitUpdateServiceName = visitor.visitUpdateServiceName) === null || _visitor_visitUpdateServiceName === void 0 ? void 0 : _visitor_visitUpdateServiceName.call(visitor, change.value);
        case "updateServiceDescription":
            var _visitor_visitUpdateServiceDescription;
            return (_visitor_visitUpdateServiceDescription = visitor.visitUpdateServiceDescription) === null || _visitor_visitUpdateServiceDescription === void 0 ? void 0 : _visitor_visitUpdateServiceDescription.call(visitor, change.value);
        case "updateServiceTerms":
            var _visitor_visitUpdateServiceTerms;
            return (_visitor_visitUpdateServiceTerms = visitor.visitUpdateServiceTerms) === null || _visitor_visitUpdateServiceTerms === void 0 ? void 0 : _visitor_visitUpdateServiceTerms.call(visitor, change.value);
        case "removeServiceTerms":
            var _visitor_visitRemoveServiceTerms;
            return (_visitor_visitRemoveServiceTerms = visitor.visitRemoveServiceTerms) === null || _visitor_visitRemoveServiceTerms === void 0 ? void 0 : _visitor_visitRemoveServiceTerms.call(visitor, change.value);
        case "updateServiceBilledUpon":
            var _visitor_visitUpdateServiceBilledUpon;
            return (_visitor_visitUpdateServiceBilledUpon = visitor.visitUpdateServiceBilledUpon) === null || _visitor_visitUpdateServiceBilledUpon === void 0 ? void 0 : _visitor_visitUpdateServiceBilledUpon.call(visitor, change.value);
        case "updateServiceBundle":
            var _visitor_visitUpdateServiceBundle;
            return (_visitor_visitUpdateServiceBundle = visitor.visitUpdateServiceBundle) === null || _visitor_visitUpdateServiceBundle === void 0 ? void 0 : _visitor_visitUpdateServiceBundle.call(visitor, change.value);
        case "removeServiceBundle":
            var _visitor_visitRemoveServiceBundle;
            return (_visitor_visitRemoveServiceBundle = visitor.visitRemoveServiceBundle) === null || _visitor_visitRemoveServiceBundle === void 0 ? void 0 : _visitor_visitRemoveServiceBundle.call(visitor, change.value);
        case "addService":
            var _visitor_visitAddService;
            return (_visitor_visitAddService = visitor.visitAddService) === null || _visitor_visitAddService === void 0 ? void 0 : _visitor_visitAddService.call(visitor, change.value);
        case "terminateService":
            var _visitor_visitTerminateService;
            return (_visitor_visitTerminateService = visitor.visitTerminateService) === null || _visitor_visitTerminateService === void 0 ? void 0 : _visitor_visitTerminateService.call(visitor, change.value);
        case "cancelService":
            var _visitor_visitCancelService;
            return (_visitor_visitCancelService = visitor.visitCancelService) === null || _visitor_visitCancelService === void 0 ? void 0 : _visitor_visitCancelService.call(visitor, change.value);
        case "updateServiceIntegratedClass":
            var _visitor_visitUpdateServiceIntegratedClass;
            return (_visitor_visitUpdateServiceIntegratedClass = visitor.visitUpdateServiceIntegratedClass) === null || _visitor_visitUpdateServiceIntegratedClass === void 0 ? void 0 : _visitor_visitUpdateServiceIntegratedClass.call(visitor, change.value);
        case "updateManualPayments":
            var _visitor_visitUpdateManualPayments;
            return (_visitor_visitUpdateManualPayments = visitor.visitUpdateManualPayments) === null || _visitor_visitUpdateManualPayments === void 0 ? void 0 : _visitor_visitUpdateManualPayments.call(visitor, change.value);
        case "updateCoverCreditCardFees":
            var _visitor_visitUpdateCoverCreditCardFees;
            return (_visitor_visitUpdateCoverCreditCardFees = visitor.visitUpdateCoverCreditCardFees) === null || _visitor_visitUpdateCoverCreditCardFees === void 0 ? void 0 : _visitor_visitUpdateCoverCreditCardFees.call(visitor, change.value);
        case "updateLegalTermsDocuments":
            var _visitor_visitUpdateLegalTermsDocuments;
            return (_visitor_visitUpdateLegalTermsDocuments = visitor.visitUpdateLegalTermsDocuments) === null || _visitor_visitUpdateLegalTermsDocuments === void 0 ? void 0 : _visitor_visitUpdateLegalTermsDocuments.call(visitor, change.value);
        case "updateAmendmentsApprovalMethod":
            var _visitor_visitUpdateAmendmentsApprovalMethod;
            return (_visitor_visitUpdateAmendmentsApprovalMethod = visitor.visitUpdateAmendmentsApprovalMethod) === null || _visitor_visitUpdateAmendmentsApprovalMethod === void 0 ? void 0 : _visitor_visitUpdateAmendmentsApprovalMethod.call(visitor, change.value);
        case "updateInvoicesApprovalMethod":
            var _visitor_visitUpdateInvoicesApprovalMethod;
            return (_visitor_visitUpdateInvoicesApprovalMethod = visitor.visitUpdateInvoicesApprovalMethod) === null || _visitor_visitUpdateInvoicesApprovalMethod === void 0 ? void 0 : _visitor_visitUpdateInvoicesApprovalMethod.call(visitor, change.value);
        case "addCustomPage":
            var _visitor_visitAddCustomPage;
            return (_visitor_visitAddCustomPage = visitor.visitAddCustomPage) === null || _visitor_visitAddCustomPage === void 0 ? void 0 : _visitor_visitAddCustomPage.call(visitor, change.value);
        case "updateCustomPage":
            var _visitor_visitUpdateCustomPage;
            return (_visitor_visitUpdateCustomPage = visitor.visitUpdateCustomPage) === null || _visitor_visitUpdateCustomPage === void 0 ? void 0 : _visitor_visitUpdateCustomPage.call(visitor, change.value);
        default:
            return assertUnreachable(change);
    }
}
export function acceptAmendmentDraftChangeExhaustive(change, visitor) {
    acceptAmendmentDraftChange(change, visitor);
}
export const makeUpdateServiceCost = (serviceId, cost)=>({
        type: "updateServiceCost",
        value: {
            serviceId,
            cost,
            conflicts: []
        }
    });
export const makeUpdateNetTerms = (netTerms)=>({
        type: "updateNetTerms",
        value: {
            netTerms: makeNetTerms(netTerms)
        }
    });
export const makeUpdateServiceName = (serviceId, name)=>({
        type: "updateServiceName",
        value: {
            serviceId,
            name
        }
    });
export const makeUpdateServiceDescription = (serviceId, description)=>({
        type: "updateServiceDescription",
        value: {
            serviceId,
            description
        }
    });
export const makeUpdateServiceTerms = (serviceId, terms)=>({
        type: "updateServiceTerms",
        value: {
            serviceId,
            terms
        }
    });
export const makeRemoveServiceTerms = (serviceId)=>({
        type: "removeServiceTerms",
        value: {
            serviceId
        }
    });
export const makeUpdateServiceBilledUpon = (serviceId, billedUpon)=>({
        type: "updateServiceBilledUpon",
        value: {
            serviceId,
            billedUpon
        }
    });
export const makeUpdateServiceBundle = (serviceId, bundle)=>({
        type: "updateServiceBundle",
        value: {
            serviceId,
            bundle
        }
    });
export const makeRemoveServiceBundle = (serviceId)=>({
        type: "removeServiceBundle",
        value: {
            serviceId
        }
    });
export const makeAddService = (serviceId, service)=>({
        type: "addService",
        value: {
            serviceId,
            service
        }
    });
export const makeTerminateService = (serviceId)=>({
        type: "terminateService",
        value: {
            serviceId
        }
    });
export const makeCancelService = (serviceId)=>({
        type: "cancelService",
        value: {
            serviceId
        }
    });
export const makeUpdateServiceIntegratedClass = (serviceId, integratedClass)=>({
        type: "updateServiceIntegratedClass",
        value: {
            serviceId,
            integratedClass
        }
    });
export const makeUpdateManualPayments = (allowManualPayments)=>({
        type: "updateManualPayments",
        value: {
            allowManualPayments
        }
    });
export const makeUpdateCoverCreditCardFees = (coverCreditCardFees)=>({
        type: "updateCoverCreditCardFees",
        value: {
            coverCreditCardFees
        }
    });
export const makeUpdateLegalTermsDocuments = (legalTermsDocuments)=>({
        type: "updateLegalTermsDocuments",
        value: {
            legalTermsDocuments
        }
    });
export const makeUpdateAmendmentsApprovalMethod = (amendmentsApprovalMethod)=>({
        type: "updateAmendmentsApprovalMethod",
        value: {
            amendmentsApprovalMethod
        }
    });
export const makeUpdateInvoicesApprovalMethod = (invoicesApprovalMethod)=>({
        type: "updateInvoicesApprovalMethod",
        value: {
            invoicesApprovalMethod
        }
    });
export const makeAddCustomPage = (page)=>({
        type: "addCustomPage",
        value: {
            page
        }
    });
export const makeUpdateCustomPage = (page)=>({
        type: "updateCustomPage",
        value: {
            page
        }
    });
